import React, { useEffect, useId, useRef } from "react";
import { LoaderCircle, ShieldCheck, TriangleAlert, X } from "lucide-react";
import "./ConfirmDialog.css";
export interface AmbassadorConfirmation {
  title: string;
  description: string;
  label: string;
  action: () => Promise<unknown>;
  danger?: boolean;
}
export default function ConfirmDialog({
  confirmation,
  busy,
  onClose,
}: {
  confirmation: AmbassadorConfirmation | null;
  busy: boolean;
  onClose: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const id = useId();
  useEffect(() => {
    if (confirmation && !dialog.current?.open) dialog.current?.showModal();
    else if (!confirmation && dialog.current?.open) dialog.current.close();
  }, [confirmation]);
  return (
    <dialog
      ref={dialog}
      className="amb-dialog"
      aria-labelledby={id}
      aria-describedby={`${id}-description`}
      data-danger={confirmation?.danger || undefined}
      onCancel={(e) => {
        e.preventDefault();
        if (!busy) onClose();
      }}
    >
      {confirmation && (
        <>
          <div className="amb-confirm-top">
            <span className="amb-confirm-symbol" aria-hidden="true">
              {confirmation.danger ? (
                <TriangleAlert size={23} />
              ) : (
                <ShieldCheck size={23} />
              )}
            </span>
            <button
              type="button"
              className="amb-confirm-close"
              aria-label="بستن پنجره تأیید"
              disabled={busy}
              onClick={onClose}
            >
              <X size={18} aria-hidden="true" />
            </button>
          </div>
          <span className="amb-eyebrow">بررسی نهایی</span>
          <h2 id={id}>{confirmation.title}</h2>
          <p id={`${id}-description`} className="amb-confirm-description">
            {confirmation.description}
          </p>
          <div className="amb-row amb-confirm-actions">
            <button
              type="button"
              disabled={busy}
              className="amb-secondary"
              onClick={onClose}
              autoFocus
            >
              بازگشت
            </button>
            <button
              type="button"
              disabled={busy}
              className={confirmation.danger ? "amb-danger" : ""}
              onClick={async () => {
                await confirmation.action();
                onClose();
              }}
            >
              {busy && (
                <LoaderCircle
                  size={16}
                  className="amb-confirm-spin"
                  aria-hidden="true"
                />
              )}
              {busy ? "در حال ثبت…" : confirmation.label}
            </button>
          </div>
        </>
      )}
    </dialog>
  );
}
